import { render, staticRenderFns } from "./ProjectAlarms.vue?vue&type=template&id=2f08e75f&"
import script from "./ProjectAlarms.vue?vue&type=script&lang=js&"
export * from "./ProjectAlarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports